
import swal from "sweetalert";
import { replaceText } from "./utils";
import { updateRequestItem, saveRequest, cruceProducts } from '../dataApi'
import { del } from "vue";

export const setAutorize = async (items, selected, request, ref, zoneId) => {
    const cantSelected = selected.length
    const cantItems = items.length
    let goProcess = true
    const status = {
        detail: "",
        code: 200,
        data: null
    }
    let statusRequest = 'AUTORIZADO'
    if (cantSelected === 0) {
        const shouldContinue = await swal({
            text: "Debe seleccionar al menos un item para Autorizar",
            icon: "warning",
            button: "OK"
        })
        if (shouldContinue) {
            return false
        }
    }

    if (cantSelected !== cantItems) {
        const shouldProcess = await swal({
            text: "Se procede a autorizar los items seleccionados, los no seleccionados seran rechazados, ¿Desea continuar?",
            icon: "info",
            buttons: ["Cancelar", "Continuar"]
        })

        if (!shouldProcess) {
            return false
        }
    }

    const setFinal = await swal({ text: "Se procede a autorizar los items seleccionados, ¿Desea continuar?", icon: "info", buttons: ["Cancelar", "Continuar"], })
    if (!setFinal) {
        return false
    }

    const cruce = await cruceProducts(selected)

    const errores = cruce.data.filter(item => item.productId === null)
    if (errores.length > 0) {
        status.data = errores
        status.code = 400
        status.detail = "Error al cruzar productos"
        status.data = subirErrores(errores)
        return status
    }

    if (goProcess) {
        const validateStatus = ref.toLowerCase().includes('sol') ? true : false;
        const productsData = zoneId ? filterInventoryByZoneId(cruce.data, zoneId) : cruce.data

        let productsAvailable = [];
        let productsNotAvailable = [];
        status.detail = 'Se ha autorizado exitosamente la solicitud';

        console.log("SAvalidateStatus", validateStatus)

        if (validateStatus) {
            productsData.forEach(item => {
                const inventoryDisp = (item.product?.inventory?.quantity - item.product?.inventory?.quantityLock);
                console.log("SAEvaluamos item", item.product)
                if (inventoryDisp >= item.quantity) {
                    console.log("SAitem disponible", item)
                    productsAvailable.push(item)
                } else if (inventoryDisp > 0) {
                    console.log("SAitem parcialmente disponible", item)
                    const availableItem = { ...item, quantity: inventoryDisp }
                    productsAvailable.push(availableItem)
                    const notAvailableItem = { ...item, quantity: item.quantity - inventoryDisp }
                    productsNotAvailable.push(notAvailableItem)
                } else {
                    console.log("SAitem no disponible", item)
                    productsNotAvailable.push(item)
                }
            })
            if (productsNotAvailable.length > 0 && productsAvailable.length === 0) {
                const shouldContinue = await swal({
                    text: `No existen en inventario productos disponibles para autorizar. \n 
                    ¿Desea generar una solicitud AUT para la compra de los productos no disponibles? \n 
                    Nota: esta solicitud quedara anulada y sera reemplazada por la solicitud AUT`,
                    icon: "error",
                    buttons: ["Cancelar", "Continuar"]
                })
                if (!shouldContinue) {
                    return false
                } else {
                    statusRequest = 'ANULADO'
                    status.detail = 'Se ha anulado la solicitud';
                }
            }
        } else {
            productsAvailable = productsData
        }
        const updateRequestDto = {
            id: request,
            ref,
            zoneId,
            status: statusRequest,
            quoteRequest: true,
            purchaseOrder: false,
            purchase: false,
            items: productsAvailable.map(item => ({
                id: item.id,
                quantity: item.quantity,
                productId: item.productId,
                categoryId: item.category.id,
                finalEmployeeId: item.employee.id,
            }))
        }
        console.log("SAupdateRequestDto", updateRequestDto)
        await updateRequestItem(updateRequestDto);

        if (productsNotAvailable.length > 0 && validateStatus) {
            console.log("SAproductsNotAvailable", productsNotAvailable)
            const refAut = replaceText(ref, 'Sol', 'Aut')
            status.detail = status.detail + ` y se ha creado la solicitud ${refAut} para la compra de los productos no disponibles`;
            const createdRequestDto = {
                ref: replaceText(ref, 'Sol', 'Aut'),
                status: 'EN PROCESO DE COMPRA',
                quoteRequest: false,
                purchaseOrder: true,
                purchase: false,
                delivery: false,
                zoneId: zoneId,
                items: productsNotAvailable.map(item => ({
                    quantity: item.quantity,
                    productId: item.productId,
                    categoryId: item.category.id,
                    finalEmployeeId: item.employee.id,
                    observation: "Generado Aut por no Stock",
                    sex: item.employee.gender
                }))
            }
            console.log("SAcreatedRequestDto", createdRequestDto)
            await saveRequest(createdRequestDto);
        }
        return status
    }

}

const subirErrores = (errores) => {
    console.log("SAsubirErrores", errores)
    const headers = [
        { text: 'Nombre', value: 'employeeName' },
        { text: 'Sexo', value: 'sex' },
        { text: 'Talla', value: 'size' },
        { text: 'Cantidad', value: 'quantity' },
        { text: 'Categoria', value: 'categoryName' },
        { text: 'Referencia', value: 'ref' },
    ]
    const items = errores.map(error => ({
        employeeName: error.employee.firstName + ' ' + error.employee.fatherName,
        categoryName: error.category.name,
        sex: error.employee.gender,
        size: `U:${error.employee.sizeUniform}-P:${error.employee.sizePants}-M:${error.employee.sizeMescal}`,
        quantity: error.quantity,
        ref: error.category.sizeRef
    }))
    return {
        headers,
        items
    }
}

const filterInventoryByZoneId = (productsArray, targetZoneId) => {
    return productsArray.map(product => {
        const filteredProduct = JSON.parse(JSON.stringify(product));
        console.log("SAfilteredProduct", filteredProduct)
        if (filteredProduct.product && Array.isArray(filteredProduct.product.inventory)) {
            const matchingInventory = filteredProduct.product.inventory.find(inv => inv.zoneId === targetZoneId);
            filteredProduct.product.inventory = matchingInventory;// && matchingInventory.length > 0 ? matchingInventory[0] : null;
        }

        return filteredProduct;
    });
}